import React, { useState, useEffect } from 'react';
import { Button } from '../../shared';
import { popup } from '../../../utils';
import { BUTTON, ROUTES, SKU_COLUMN } from '../../../constants';
import { useNavigate } from 'react-router-dom';
import { useDebounce } from '../../../hooks';
import { mixBoxPackage, submitSkuMixBoxPackage } from '../../../service/package';
import { packageDataCompiler } from '../../../utils/dataCompiler/packageDataCompiler';
import { DropDownArrow2 } from '../../../assets/icons';
import { Table } from '../../common';

const MixBoxInputTable = () => {
  const [mixBoxData, setMixBoxData] = useState([]);
  const [selectedSKU, setSelectedSKU] = useState({});
  const [qty, setQty] = useState(0);
  const [skuList, setSkuList] = useState([]);
  const [mode, setMode] = useState(0);
  const [availableSku, setAvailableSku] = useState([]);
  const [isDropDownLoading, setIsDropDownLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const navigate = useNavigate();

  const getMixBoxList = useDebounce(() => {
    setIsDropDownLoading(true);
    mixBoxPackage({
      data: {},
    })
      .then((response) => {
        setIsDropDownLoading(false);
        setMixBoxData(response.data);
        setAvailableSku(response.data);
      })
      .catch(() => {
        setIsDropDownLoading(false);
      });
  }, 400);

  useEffect(() => {
    setIsDropDownLoading(true);
    getMixBoxList();
  }, []);

  const handleSubmit = () => {
    setIsSubmitLoading(true);
    const data = skuList.map((item) => {
      return {
        id: item.id,
        quantity: item.quantity,
      };
    });
    submitSkuMixBoxPackage({
      data: { data },
    })
      .then((response) => {
        setIsSubmitLoading(false);
        popup('success', response.message);
        navigate(ROUTES.PACKAGE_BLP_OVERVIEW, {
          state: { data: packageDataCompiler(response.data)[0] },
        });
      })
      .catch(() => {
        setIsSubmitLoading(false);
        // navigate(ROUTES.PACKAGE);
        window.history.back();
      });
  };
  const handleListClick = (sku) => {
    setSelectedSKU(sku);
  };
  const handleQtyChange = (e) => {
    let value = e.target.value;
    if (value !== '' && !/^\d+$/.test(value)) {
      return;
    }
    if (value === '') {
      setQty('');
      return;
    }
    value = +value;
    if (mode === 0 && value <= selectedSKU.quantity) {
      setQty(value);
    } else if (
      mode !== 0 &&
      value !== selectedSKU.quantity &&
      value <= mixBoxData.find((box) => box.id === selectedSKU.id)?.quantity
    ) {
      setQty(value);
      setMode(2);
    }
  };

  const addSku = () => {
    if (mode === 0) {
      setSkuList((pre) => [...pre, { id: selectedSKU.id, name: selectedSKU.name, quantity: qty }]);
    } else if (mode === 2) {
      setSkuList((pre) => [
        ...pre.filter((sku) => sku.id !== selectedSKU.id),
        {
          id: selectedSKU.id,
          name: selectedSKU.name,
          quantity: qty,
        },
      ]);
    }

    setSelectedSKU({});
    setQty(0);
    setMode(0);
    setSearchValue('');

    setAvailableSku(mixBoxData.filter((sku) => !skuList.map((list) => list.id).includes(sku.id)));
  };
  
  const handleAction = ({ data, action }) => {
    if (action === 'edit') {
      setSelectedSKU(data);
      setQty(data.quantity);
      setMode(1);
    } else {
      setSkuList((pre) => pre.filter((sku) => sku.id !== data.id));
      setSelectedSKU({});
      setQty(0);
      setMode(0);
    }
  };
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchValue(e.target.value);

    if (!value.trim()) {
      setAvailableSku(mixBoxData.filter((sku) => !skuList.map((list) => list.id).includes(sku.id)));
      return;
    }

    const keywords = value.split(' ');
    const filteredSku = mixBoxData
      .filter((sku) => !skuList.map((list) => list.id).includes(sku.id))
      .filter((sku) => keywords.every((keyword) => sku.name.toLowerCase().includes(keyword)));

    setAvailableSku(filteredSku.length ? filteredSku : 'No records found');
  };
  useEffect(() => {
    setAvailableSku(mixBoxData.filter((sku) => !skuList.map((list) => list.id).includes(sku.id)));
  }, [skuList, mixBoxData]);

  return (
    <div className="data-content h-100">
      <div className="w-100 h-100 editing-container">
        <div className="row h-100 d-flex align-items-center justify-content-center">
          <div className="edit-container py-4 px-lg-5 px-4  overflow-hidden table-new-div bg-white data-box w-100 h-100">
            <div className="d-flex gap-3 w-100 align-items-center">
              <div className="custom-dropdown-4 width-65 ">
                <div className="dropdown w-100">
                  <button
                    className="dropdown-toggle bg-white w-100 d-flex align-items-center justify-content-between"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false">
                    {Object.keys(selectedSKU).length ? selectedSKU.name : 'Select Items'}
                    <DropDownArrow2 />
                  </button>
                  <div className="dropdown-menu p-0 w-100" aria-labelledby="dropdownMenuButton1">
                    <div className="w-100 mt-2 px-1">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search.."
                        value={searchValue}
                        onChange={(e) => handleSearch(e)}
                      />
                    </div>
                    {!isDropDownLoading ? (
                      <ul className="list-data-area w-100 m-0 p-0">
                        {Array.isArray(availableSku) ? (
                          availableSku.map((sku) => (
                            <li key={sku.id} onClick={() => handleListClick(sku)} className="px-2">
                              <div className="d-flex align-items-center w-100">
                                <div
                                  className="dropdown-item t-wrap d-flex align-items-center"
                                  style={{
                                    flex: '0 0 80%',
                                    minWidth: 0,
                                    wordBreak: 'break-word',
                                    whiteSpace: 'normal',
                                    marginTop: '2px',
                                    padding: '12px 0px',
                                    lineHeight: '1.4',
                                  }}>
                                  {sku.name}
                                </div>
                                {typeof sku.quantity === 'number' && (
                                  <div
                                    className="dropdown-item t-wrap mx-3 d-flex align-items-center justify-content-end"
                                    style={{
                                      flex: '0 0 20%',
                                      textAlign: 'right',
                                      minWidth: 0,
                                    }}>
                                    {sku.quantity} Pcs
                                  </div>
                                )}
                              </div>
                            </li>
                          ))
                        ) : (
                          <li className="px-2">
                            <div
                              className="dropdown-item t-wrap d-flex align-items-center text-break"
                              style={{
                                wordBreak: 'break-word',
                                whiteSpace: 'normal',
                                maxWidth: '100%',
                                marginTop: '2px',
                                padding: '12px 0px',
                                lineHeight: '1.4',
                              }}>
                              {availableSku}
                            </div>
                          </li>
                        )}
                      </ul>
                    ) : (
                      <div className="text-center my-2">
                        <span
                          className="spinner-border spinner-border-sm text-primary"
                          role="status"
                        />
                        <span className="ms-2">Loading...</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <input
                className="quantity-input w-20 t-wrap"
                type="number"
                value={qty || ''}
                onChange={(e) => handleQtyChange(e)}
                disabled={!Object.keys(selectedSKU).length}
                onWheel={(e) => e.target.blur()}
                placeholder={
                  Object.keys(selectedSKU).length
                    ? `Available Qty : ${mixBoxData.filter((box) => selectedSKU.id === box.id)[0].quantity}`
                    : 'Enter Quantity'
                }
              />
              <Button
                disabled={!qty}
                clickHandler={addSku}
                className={`quantity-input  ${qty ? '' : 'disabled'} `}>
                {mode === 0 ? 'Add' : mode === 1 ? 'cancel' : 'update'}
              </Button>
            </div>
            <div className="d-flex justify-content-end align-items-center mt-5 pt-5">
              <Button
                disabled={!skuList.length || isSubmitLoading}
                className={`border-0 blue-btn me-2 d-flex align-items-center justify-content-center py-2 px-3 ${!skuList.length || isSubmitLoading ? 'disabled' : ''}`}
                clickHandler={handleSubmit}>
                {isSubmitLoading && (
                  <span
                    className="spinner-border spinner-border-sm text-white me-2"
                    role="status"
                  />
                )}
                {BUTTON.TRUE_SUBMIT}
              </Button>
            </div>
            <div className=" mt-2 mb-2 overflow-scroll h-75">
              <Table
                className="table-5"
                columns={SKU_COLUMN}
                initialData={skuList}
                func={handleAction}
                tooltip={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MixBoxInputTable;
